import Vue from "vue"
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)
const i18n = new VueI18n({
	locale: 'hu',//(navigator.language || 'en').split('-')[0],
	fallbackLocale: 'hu',
	silentFallbackWarn: true,
	messages: {
		en: require('json-loader!yaml-loader!./en.yaml'),
		hu: require('json-loader!yaml-loader!./hu.yaml')
	}
})


const mixin = Vue.extend({
    methods: {
        $languages(): {[key: string]: string} {
            return {
                en: 'english',
                hu: 'magyar'
            }
        },

        $locale(): string {
            const locale = this.$root.$i18n.locale
            const fallback = this.$root.$i18n.fallbackLocale as string
            return locale || fallback
        },

        $tt(obj: object): string {
            if (obj == null) return ''
            const locale = this.$root.$i18n.locale
            const fallback = this.$root.$i18n.fallbackLocale as string
            const ob = obj as any
            return ob[locale] || ob[fallback]
        },
        
        $money(value: string | number, currency: string): string {
            const locale = this.$root.$i18n.locale
            const fallback = this.$root.$i18n.fallbackLocale as string
            let sum = Number(value).toLocaleString(locale || fallback)
            if (value == null) return ''
            if (currency == 'HUF') return sum + ' Ft'
            else if (currency == 'EUR') return '€' + sum
            else if (currency == 'USD') return '$' + sum
            return sum + ' ' + currency
        },

        $countries(): {[key: string]: string} {
            return {
                at:	'Österreich',
                ba:	'Bosnia I Hercegovína',// Босна и Херцеговина',
                be:	'België, Belgique, Belgien',
                bg: 'България',
                ch:	'Suisse, Schweiz, Svizzera',// Svizra',
                cy: 'Κύπρος - Kıbrıs',
                cz: 'Česko',
                de:	'Deutschland',
                dk:	'Danmark',
                ee: 'Eesti',
                es:	'España, Espanya, Espainia',
                fi:	'Suomi, Finland',
                gr: 'Ελλάς',
                gb:	'United Kingdom',
                hu: 'Magyarország',
                hr: 'Hrvatska',
                ie:	'Ireland, Éire',
                it:	'Italia',
                lv: 'Latvija',
                lt: 'Lietuva',
                mt: 'Malta',
                nl:	'Nederland, Nederlân',
                no:	'Norge',
                pl:	'Polska',
                pt:	'Portugal',
                ro: 'România',
                rs:	'Srbija Србија',
                se:	'Sverige',
                sk: 'Slovensko',
                si: 'Slovenija',
                ua: 'Ukraїna Україна'
            }
        },

        $currencies() {
            return ['EUR', 'HUF', 'USD']
        }
    }
})

declare module 'vue/types/vue' {
    interface Vue {
        $languages: () => {[key: string]: string}
        $locale: () => string,
        $tt: (obj: {[key: string]: string}) => string,
        $money: (value: string | number, currency: string) => string,
        $countries: () => {[key: string]: string}
        $currencies: () => [string]
    }
}


export default {
    i18n,
    mixin
}